'use strict';

var debounce = require('lodash/debounce');
var minChars = 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
    $('.sticky-atc-container').css({
        visibility: 'visible'
    });
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $('body').addClass('modal-open');
        $('header').siblings().attr('aria-hidden', 'true');
        // Hide/show the sticky product nav when search suggestions open/close until pagebody scrolling is fixed/disabled
        $('.sticky-atc-container').css({
            visibility: 'hidden'
        });
        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    clearModals();
    $('.search-mobile .suggestions').unbind('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for Search Suggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();

    if (!(typeof (response) === 'object')) {
        $suggestionsWrapper.append(response).show();
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var $suggestions = getSuggestionsWrapper(scope);
    var $form = $suggestions.parents('form');
    if ($(scope).val().length >= minChars) {
        $form.find('.suggestions-wrapper-content').removeClass('active'); // Remove the content suggestions
        $form.find('input.search-field').attr('aria-expanded', true);
        $.spinner().stop(); // Prevent multiple overlappying spinners
        $.spinner().start();
        $.ajax({
            context: scope,
            url: $suggestions.data('url') + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        clearModals();
        $suggestions.empty();
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"], form[name="parts-enter-model-number-form"]').submit(function (e) {
        var suggestionsList = $(this).find('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field, #parts-accessories-finder-model-number').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    // ADA compliance for multiple instances of search template per page
    $('input.search-field, #search-label').each(function () {
        if ($(this).closest('.search-mobile').length > 0) {
            $(this).attr('id', $(this).attr('id') + '-mobile');
            $(this).next('label').attr('for', $(this).next('label').attr('for') + '-mobile');
        }
    });

    $('body').on('click', function (e) {
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').hide();
            $('.sticky-atc-container').css({
                visibility: 'visible'
            });
        }
    });

    // On focus of search input, show the close X, show the content suggestions after min characters input and set the fa toggle to close
    $('input.search-field').on('focus', function () {
        $('.reset-button').removeClass('d-none');
        if ($(this).val().length >= minChars) {
            $('.suggestions-wrapper-content').addClass('active');
        }
    });

    // In mobile search, on click of fa-close X, remove the ajax suggestions, clear the input value, remove the content suggestions and set the fa toggle to search
    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
        e.preventDefault();
        $('.suggestions').hide();
        $('input.search-field').val('');
        $('.suggestions-wrapper-content').removeClass('active');
        $('.sticky-atc-container').css({
            visibility: 'visible'
        });
        tearDownSuggestions();
    });

    // In header and mobile search, clear the reset-button X, clear the input value, remove the content suggestions and the ajax suggestions
    $('.site-search .reset-button').on('click touchend', function () {
        $('.reset-button').addClass('d-none');
        $('input.search-field').val('');
        $('.suggestions-wrapper-content').removeClass('active');
        $('input.search-field').attr('aria-expanded', false);
        tearDownSuggestions();
    });

    // Triggering the focus out on mobile devices on click of reset-button X
    $('.site-search .reset-button').on('click touchend', function (e) {
        e.preventDefault();
        $('input.search-field').trigger('blur');
    });

    // Toggle List View and Grid View
    $('.grid-view-link').click(function () {
        $('.grid-container, .grid-view-link').toggleClass('list');
        var $toggle = $(this);
        var curAriaLabel = $toggle.attr('aria-label');
        var altAriaLabel = $toggle.data('alt-aria-label');
        $toggle.attr('aria-label', altAriaLabel);
        $toggle.data('alt-aria-label', curAriaLabel);
    });

    $('.site-search .fa-search').click(function () {
        if ($('input.search-field').val() !== '') {
            $('input.search-field').attr('value', $('input.search-field').val());
            $('form[name="simpleSearch"]').submit();
        }
    });
};
